import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import BorderedInput from '@navi/web-ui/lib/primitives/BorderedInput/index';
import React, { useEffect } from 'react';
import styles from '../index.module.scss';
import { IRenderingEngine } from '../interfaces/index.type';

const Text: React.FC<IRenderingEngine> = props => {
  const { question, register, error, source, setValue, unregister, clearErrors } = props;
  const { text, mandatory, defaultValue, referenceId } = question;

  useEffect(() => {
    return () => {
      setValue(`${source}_${referenceId}`, undefined);
      unregister(`${source}_${referenceId}`);
      clearErrors(`${source}_${referenceId}`);
    };
  }, []);
  return (
    <div className={styles.input}>
      <BorderedInput
        {...register(`${source}_${referenceId}`, { required: mandatory })}
        labelClassName={styles.label}
        id="text"
        inputSize="full-width"
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        inputLabel={
          <>
            {text} {mandatory && <RequiredIcon />}
          </>
        }
        error={!!error?.[`${source}_${referenceId}`]}
        value={defaultValue || ''}
        // required={mandatory}
      />
    </div>
  );
};

export default Text;
